import base from "./base"

async function getNftMetadata(contract, tokenId) {
    return await base.httpReq(
        true,
        "get",
        '/nft/metadata',
        null,
        {contract, tokenId}
    )
}

async function uploadNftMetadata(metadata) {
    return await base.httpReq(
        true,
        "post",
        `/nft/metadata`,
        metadata,
        null
    )
}

export default {
    getNftMetadata,
    uploadNftMetadata
}